











import AbpBase from '@/lib/abpbase'
import { Component, Prop } from 'vue-property-decorator'
@Component
export default class PageCard extends AbpBase {
    @Prop({type:String,default:"No-Value"}) textValue:string;
};
